export const language = {
	title: 'Experience',
};
